/*
 * Actions describe changes of state in your application
 */

// We import constants to name our actions' type
import {
  SENDING_REQUEST,
  LOGIN_REQUEST,
  SSO_LOGIN_REQUEST,
  VALIDATE_MFA_REQUEST,
  LOGOUT,
  PASSWORD_REQUEST,
  PASSWORD_RESET_REQUEST,
  REQUEST_ERROR,
  CLEAR_ERROR,
  GET_LOGIN_TEXT,
  GET_MFA_STATUS,
  REQUEST_FORGOT_PW,
  REQUEST_FORGOT_PW_CHANGE,
} from './constants';

/**
 * Sets the `currentlySending` state, which displays a loading indicator during requests
 * @param  {boolean} sending True means we're sending a request, false means we're not
 */
export function sendingRequest(sending) {
  return { type: SENDING_REQUEST, sending };
}

/**
 * Tells the app we want to log in a user
 * @param  {object} data          The data we're sending for log in
 * @param  {string} data.username The username of the user to log in
 * @param  {string} data.password The password of the user to log in
 */
export function loginRequest(data) {
  return { type: LOGIN_REQUEST, data };
}
export function ssoLoginRequest(data) {
  return { type: SSO_LOGIN_REQUEST, data };
}

export function validateMfaRequest(data) {
  return { type: VALIDATE_MFA_REQUEST, data };
}

/**
 * Tells the app we want to log out a user
 */
export function logout() {
  return { type: LOGOUT };
}

/**
 * Tells the app we want to log in a user
 * @param  {object} data
 * @param  {string} data.password               The new password
 * @param  {string} data.passwordConfirmation   The confirmed password
 */
export function passwordRequest(data) {
  return { type: PASSWORD_REQUEST, data };
}

export function passwordResetRequest(data) {
  return { type: PASSWORD_RESET_REQUEST, data };
}
/**
 * Sets the `error` state to the error received
 * @param  {object} error The error we got when trying to make the request
 */
export function requestError(error) {
  return { type: REQUEST_ERROR, error };
}

/**
 * Sets the `error` state as empty
 */
export function clearError() {
  return { type: CLEAR_ERROR };
}

/**
 * Get login help text to displays
 */
export function fetchLoginHelperText() {
  return { type: GET_LOGIN_TEXT };
}

export function fetchMfaStatus() {
  return { type: GET_MFA_STATUS };
}

export function validateUsernameRequest(username) {
  return { type: REQUEST_FORGOT_PW, username };
}

export function submitForgotPasswordChange(data) {
  return { type: REQUEST_FORGOT_PW_CHANGE, data };
}
